import React from 'react';
import { Globe, Timer, Trash2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Switch } from '../../components/ui/switch';

export const HomepageSettingsCard = ({
    homepageSettings,
    promoDateInput,
    setPromoDateInput,
    onToggleSetting,
    onSetPromoDate,
    onClearPromoDate,
}) => {
    return (
        <Card className="mb-8 border-0 bg-white/80 backdrop-blur-sm shadow-sm rounded-2xl" data-testid="homepage-settings-card">
            <CardHeader className="flex flex-row items-center justify-between pb-3">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center">
                        <Globe className="h-5 w-5 text-amber-600" />
                    </div>
                    <div>
                        <CardTitle className="font-heading text-jungle text-base">Page d'accueil</CardTitle>
                        <p className="text-xs text-muted-foreground">Controlez la visibilite des catalogues</p>
                    </div>
                </div>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex items-center justify-between p-4 rounded-xl bg-amber-50 border border-amber-100">
                        <div className="flex items-center gap-3">
                            <span className="text-2xl">🌍</span>
                            <div>
                                <p className="font-medium text-sm text-gray-900">Produits Alimentaires Africains</p>
                                <p className="text-xs text-gray-500">Carrousel sur la page d'accueil</p>
                            </div>
                        </div>
                        <Switch
                            data-testid="toggle-african-homepage"
                            checked={!!homepageSettings.show_african_homepage}
                            onCheckedChange={() => onToggleSetting('show_african_homepage')}
                        />
                    </div>
                    <div className="flex items-center justify-between p-4 rounded-xl bg-purple-50 border border-purple-100">
                        <div className="flex items-center gap-3">
                            <span className="text-2xl">✨</span>
                            <div>
                                <p className="font-medium text-sm text-gray-900">Cosmetiques Africains</p>
                                <p className="text-xs text-gray-500">Carrousel sur la page d'accueil</p>
                            </div>
                        </div>
                        <Switch
                            data-testid="toggle-cosmetics-homepage"
                            checked={!!homepageSettings.show_cosmetics_homepage}
                            onCheckedChange={() => onToggleSetting('show_cosmetics_homepage')}
                        />
                    </div>

                    {/* Promo Countdown Config */}
                    <div className="p-4 rounded-xl bg-gradient-to-r from-amber-50 to-red-50 border border-amber-200 md:col-span-2">
                        <div className="flex items-center gap-3 mb-3">
                            <div className="w-9 h-9 rounded-lg bg-amber-100 flex items-center justify-center">
                                <Timer className="w-5 h-5 text-amber-600" />
                            </div>
                            <div>
                                <p className="font-medium text-sm text-gray-900">Compte a rebours promo</p>
                                <p className="text-xs text-gray-500">
                                    {homepageSettings.promo_end_date
                                        ? `Actif jusqu'au ${new Date(homepageSettings.promo_end_date).toLocaleString('fr-FR')}`
                                        : "Aucune promo active - les prix des offres de la semaine restent toujours visibles"}
                                </p>
                            </div>
                        </div>
                        <div className="flex items-center gap-2 flex-wrap">
                            <input
                                type="datetime-local"
                                value={promoDateInput || (homepageSettings.promo_end_date ? homepageSettings.promo_end_date.slice(0, 16) : '')}
                                onChange={(e) => setPromoDateInput(e.target.value)}
                                className="flex-1 min-w-[200px] px-3 py-2 text-sm border rounded-lg focus:ring-2 focus:ring-amber-300 focus:border-amber-300"
                                data-testid="promo-end-date-input"
                            />
                            <Button
                                onClick={onSetPromoDate}
                                size="sm"
                                className="bg-amber-600 hover:bg-amber-700"
                                data-testid="promo-set-btn"
                            >
                                Activer
                            </Button>
                            {homepageSettings.promo_end_date && (
                                <Button
                                    onClick={onClearPromoDate}
                                    size="sm"
                                    variant="outline"
                                    className="text-red-600 border-red-300 hover:bg-red-50"
                                    data-testid="promo-clear-btn"
                                >
                                    <Trash2 className="w-4 h-4 mr-1" /> Supprimer
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};
